import { httpGet, httpPost } from "../../../utils/api.utils";
import {
    getLinkedCircuits,
    setLinkedCircuitColSearchStr,
    resizeLinkedCircuits,
    sortLinkedCircuits,
    selectLinkedCircuit,
    setLinkedCircuitsLoading,
    resetLinkedCircuits
} from "../../../constants/model-reducers/external/inventory/linked-circuits/linked-circuits.settings";
import { DEFAULT_TABLE_RESULT_MODEL, DEFAULT_PAGE_SIZES } from "../../../constants/external-constants";

const defaultState = () => ({
    LinkedCircuitTable: DEFAULT_TABLE_RESULT_MODEL,
    IsLoadingTable: false,
    LinkedCircuitId: 0,
    LinkedCircuitItem: undefined
});

const initialState = defaultState();

export const linkedCircuitActions = {
    getLinkedCircuits: (circuitId, pageIndex = 0) => async (dispatch, state) => {
        const { Headers, Pagination, SortedColumnName, IsSortAscending } = state().inventoryLinkedCircuit.LinkedCircuitTable;
        var formData = {
            Headers: Headers,
            PageFilter: {
                PageIndex: pageIndex !== undefined ? pageIndex : 0,
                PageSize: Pagination.PerPage,
                PageSizes: DEFAULT_PAGE_SIZES
            },
            SortedColumnName: SortedColumnName,
            IsSortAscending: IsSortAscending,
        };

        dispatch({
            type: setLinkedCircuitsLoading,
            isLoadingTable: true
        });

        var result = await httpPost(`external/inventory/getLinkedCircuit/${circuitId}`, formData);

        dispatch({
            type: getLinkedCircuits,
            linkedCircuitTable: result,
            isLoadingTable: false
        });
    },
    resizeLinkedCircuits: (pageSize) => async (dispatch, state) => {
        dispatch({
            type: resizeLinkedCircuits,
            pageSize: parseInt(pageSize),
        });
    },
    setResetCircuits: () => async (dispatch, state) =>{
        const { LinkedCircuitTable } = state().inventoryLinkedCircuit;
        var linkCircuitTableHeaderUpd = {
            ...LinkedCircuitTable,
            "Headers": {}
        }

        dispatch({
            type: setLinkedCircuitColSearchStr,
            linkedCircuitTable: linkCircuitTableHeaderUpd
        });
    },
    setLinkedCircuitColSearchStr: (event, key) => async (dispatch, state) => {
        var val = event.target.value;
        const { LinkedCircuitTable } = state().inventoryLinkedCircuit;
        var linkCircuitTableHeaderUpd = {
            ...LinkedCircuitTable,
            "Headers": {
                ...LinkedCircuitTable.Headers,
                [key]: {

                    ...LinkedCircuitTable.Headers[key],
                    searchString: val
                }
            }
        }

        dispatch({
            type: setLinkedCircuitColSearchStr,
            linkedCircuitTable: linkCircuitTableHeaderUpd
        });
    },
    sortLinkedCircuits: (columnName, isSortedAsc, circuitId) => async (dispatch, state) => {
        const { Headers, Pagination } = state().inventoryLinkedCircuit.LinkedCircuitTable;
        var formData = {
            Headers: Headers,
            PageFilter: {
                PageIndex: Pagination.PageNumber,
                PageSize: Pagination.PerPage,
                PageSizes: DEFAULT_PAGE_SIZES
            },
            SortedColumnName: columnName,
            IsSortAscending: isSortedAsc,
        };

        var result = await httpPost(`external/inventory/getLinkedCircuit/${circuitId}`, formData);

        dispatch({
            type: sortLinkedCircuits,
            linkedCircuitTable: result
        });
    },
    resetLinkedCircuits: () => (dispatch, state) => {
        dispatch({
            type: resetLinkedCircuits
        })
    },
    selectLinkedCircuit: (data) => (dispatch, state) => {
        dispatch({
            type: selectLinkedCircuit,
            linkedCircuitId: data.linkedCircuitId,
            linkedCircuitItem: data.linkedCircuitItem
        })
    },
    getLinkedCircuitDetails: (linkCircuitId) => async (dispatch, state) => {
        var result = await httpGet(`external/inventory/getInventoryCircuitItem/${linkCircuitId}`);

        return result.data;
    }
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case getLinkedCircuits:
            return {
                ...state,
                LinkedCircuitTable: action.linkedCircuitTable,
                IsLoadingTable: action.isLoadingTable
            };
        case resizeLinkedCircuits:
            return {
                ...state,
                LinkedCircuitTable: {
                    ...state.LinkedCircuitTable,
                    Pagination: {
                        ...state.LinkedCircuitTable.Pagination,
                        PerPage: action.pageSize
                    }
                }
            };
        case setLinkedCircuitColSearchStr:
            return {
                ...state,
                LinkedCircuitTable: action.linkedCircuitTable
            };
        case sortLinkedCircuits:
            return {
                ...state,
                LinkedCircuitTable: action.linkedCircuitTable
            };
        case selectLinkedCircuit:
            return {
                ...state,
                LinkedCircuitItem: action.linkedCircuitItem,
                LinkedCircuitId: action.linkedCircuitId
            }
        case setLinkedCircuitsLoading:
            return {
                ...state,
                IsLoadingTable: action.isLoadingTable
            };
        case resetLinkedCircuits:
            return {
                ...initialState
            };
        default:
            return state;
    }
}